// TinyMCE для полей .tinymce-content. Интервал периодически сканирует документ и поднимает редакторы
// на новых полях: статические — сразу после загрузки страницы, динамически подгруженные
// (например, форма фильма в модалке через form-modal) — в течение 100 мс после появления.
let filemanagerPluginAdded = false; // защита от повторного добавления плагина

function registerFileManagerPlugin() {
    if (filemanagerPluginAdded || !window.tinymce) return;
    filemanagerPluginAdded = true;
    tinymce.PluginManager.add('filemanager', function (editor) {
        editor.ui.registry.addButton('filemanager', {
            text: '📁',
            tooltip: 'Файловый менеджер',
            onAction: function () {
                if (typeof window.openFileManagerModal === 'function') {
                    window.openFileManagerModal(editor);
                }
            },
        });
    });
}

// Скину больше не выбирается здесь: обе скины — отдельные файлы, <link> активной подвешивает
// syncTinymceSkins() по data-theme, а в init передаётся skin: false.
function getThemeSettings() {
    return {
        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px; background:var(--theme-white); color:var(--theme-dark); }',
    };
}

// Скины oxide и oxide-dark не могут жить в одном CSS (одинаковые селекторы, одна перекрывает другую),
// поэтому каждая — отдельный файл. Держим <link> только у активной скины по data-theme.
function syncTinymceSkins() {
    let body = document.body;
    if (!body) return;

    let isDark = document.documentElement.getAttribute('data-theme') === 'dark';
    let activeId = isDark ? "tinymce-dark-skin" : "tinymce-light-skin";
    let inactiveId = isDark ? "tinymce-light-skin" : "tinymce-dark-skin";
    let activeUrl = body.getAttribute("data-" + activeId);

    if (activeUrl) {
        let link = document.getElementById(activeId);
        if (!link) {
            link = document.createElement("link");
            link.id = activeId;
            link.rel = "stylesheet";
            link.href = activeUrl;
            document.head.appendChild(link);
        }
    }

    let inactiveLink = document.getElementById(inactiveId);
    if (inactiveLink) inactiveLink.remove();
}

// Уничтожаем сиротские редакторы: целевой элемент больше не в документе (модалку закрыли и очистили её содержимое).
// Без этого старый инстанс остаётся в реестре TinyMCE по id поля, а повторный init нового поля с тем же id
// отклоняется — поле остаётся простым textarea до перезагрузки страницы. В v8 нет массива tinymce.editors — только tinymce.get().
function removeOrphanedEditors() {
    if (!window.tinymce || typeof window.tinymce.get !== "function") return;

    jQuery.each(window.tinymce.get(), function (i, ed) {
        let el = null;
        try {
            el = ed.getElement();
        } catch (err) {
            // Редактор в промежуточном состоянии — пропускаем.
        }
        if (!el || ed.removed || el.isConnected) return;

        try {
            ed.remove();
        } catch (err) {
            // Не ломаем скан из-за одного проблемного редактора.
        }
    });
}

// Синхронизировать содержимое TinyMCE-редакторов внутри container в их textarea ДО сериализации формы.
// AJAX-отправка (openModalForm / utils/ajax-form) не вызывает нативного submit события, а без него
// TinyMCE сам не переносит контент редактора в поле — FormData соберёт устаревшее значение textarea.
window.syncTinymceEditorsIn = function (container) {
    if (!container || !window.tinymce || typeof window.tinymce.get !== "function") return;

    jQuery.each(window.tinymce.get(), function (i, ed) {
        let el = null;
        try {
            el = ed.getElement();
        } catch (err) {
            // Редактор в промежуточном состоянии — пропускаем.
        }
        // initialized — редактор ещё может подниматься по интервалу-сканеру, save() до init не вызываем.
        if (el && ed.initialized && container.contains(el)) ed.save();
    });
};

jQuery(document).ready(function () {
    // Скины синхронизируем до первого init редакторов и при каждой смене темы без перезагрузки.
    syncTinymceSkins();

    new MutationObserver(syncTinymceSkins).observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['data-theme'],
    });

    setInterval(function () {
        if (!window.tinymce) return;

        // Сначала чистим сирот — они блокируют init новых полей с тем же id (см. removeOrphanedEditors).
        removeOrphanedEditors();

        let els = jQuery(".tinymce-content");
        if (!els.length) return;

        registerFileManagerPlugin();

        // Отмечаем текущую пачку и поднимаем её ОДНИМ вызовом init: TinyMCE 8 принимает только строковый
        // selector, а поля на странице могут дублировать id (два #description в contests/show) —
        // поэлементные init молча потеряют второе поле с уже занятым id.
        els.each(function () { this.setAttribute("data-tinymce-init", "1"); });

        tinymce.init({
            selector: "[data-tinymce-init]",
            plugins: 'code lists link image charmap table wordcount filemanager',
            toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent | removeformat | filemanager | code | help',
            menubar: false,
            height: 400,
            promotion: false,
            branding: false,
            content_css: false,
            convert_urls: false,
            // ru-локализация зарегистрирована в бандле через tinymce.addI18n (dashboard/tinymce-langs/ru.js).
            language: 'ru',
            setup: function (editor) {
                function updateEditorTheme() {
                    let isDark = document.documentElement.getAttribute('data-theme') === 'dark';
                    editor.getBody().style.background = isDark ? '#16191c' : '#ffffff';
                    editor.getBody().style.color = isDark ? '#f8f9fa' : '#212529';
                }

                editor.on('init', function () {
                    updateEditorTheme();
                });

                // Слушаем смену темы
                new MutationObserver(updateEditorTheme).observe(document.documentElement, {
                    attributes: true,
                    attributeFilter: ['data-theme'],
                });
            },
            license_key: 'gpl',
            // skin: false — скины идут отдельными файлами сборки, <link> подвешивает syncTinymceSkins(); TinyMCE не должен тянуть /tinymce/skins.
            skin: false,
            content_style: getThemeSettings().content_style,
        });

        // Снимаем метку и класс синхронно: следующий скан не подхватит уже поднятые поля.
        // Безопасно — чистка сирот выше гарантирует отсутствие конфликта в реестре по id, так что init
        // точно создаст редактор для каждого размеченного поля; сам редактор держит ссылку на элемент, а не на selector.
        els.each(function () {
            this.removeAttribute("data-tinymce-init");
            this.classList.remove("tinymce-content");
        });
    }, 200);
});
